import React from 'react';
import { useSelector } from 'react-redux';
import { Trans } from '@wix/yoshi-flow-editor';

import { selectGroupName, selectGroupSlugById } from 'store/selectors';

import { Link } from '../../Link';

import { IActivityDescriptionProps } from './types';

export function UserJoined(props: IActivityDescriptionProps) {
  const { item, full } = props;

  const groupId = item.applicationContext?.contextId as string;

  const slug = useSelector(selectGroupSlugById(groupId));
  const groupName = useSelector(selectGroupName(groupId));

  if (!full) {
    return (
      <Trans
        i18nKey="groups-web.activity-post.user.joined"
        components={[<span />]}
      />
    );
  }

  return (
    <Trans
      values={{ groupName }}
      i18nKey="groups-web.activity-post.user.joined.with-group-name"
      components={[<span />, <Link state="group" params={{ slug }} />]}
    />
  );
}

UserJoined.displayName = 'UserJoined';
